import { Component } from '@angular/core';
import { NavController, Events, App, LoadingController } from 'ionic-angular';
import { UserData } from '../../../../providers/user-data';
import { PageBaseFull } from '../../../../core/page-base.full';
import { AppSettings } from '../../../../config/app-settings';
import { ServicesCommon } from './services.common';

@Component({
	selector: 'page-services-full',
  	templateUrl: 'services.full.html'
})

export class ServicesPageFull extends PageBaseFull {
	
	public pageSections:any;
	public loader: any;

	constructor(
		public settings: AppSettings,
		public events: Events,
		public nav: NavController,
		public userData: UserData,
		public common: ServicesCommon,
        public loadingCtrl: LoadingController,
        public app: App

	) {
		super(settings, events, nav, userData);
		this.loader = this.loadingCtrl.create();
	}

	ngAfterViewInit() {
		
	}
	
	ionViewDidEnter() {
		this.app.setTitle('Services Page');
	}
}


// WEBPACK FOOTER //
// ./src/modules/services/pages/services/services.full.ts